import React from "react";
import Navbar from "../components/navbar/Navbar";
export default function Bodiva() {
  return (
    <>
      <div className="row">
        <div className="col-md-3"></div>
        <iframe
          class="embed-responsive-item"
          width="933"
          height="700"
          src="https://app.powerbi.com/view?r=eyJrIjoiODZkZTcyYmItMjA1MS00YTBjLTg5ZjctNTEyM2Q4ZTNhNTYyIiwidCI6IjRmNTVkY2RkLTY1MzctNDM3OS1hMjNlLWMwMWYyMTdlMmE4ZSIsImMiOjh9"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
}
